import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-terms-of-service',
	templateUrl: './terms-of-service.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TermsOfServiceComponent {}
